import type { FC } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import type { TwitterAdCreateResult } from '../api';

const cellSx = { fontSize: 14, whiteSpace: 'pre-wrap', wordBreak: 'break-all' } as const;

const Cell: FC<{ value: string }> = ({ value }) => (
  <TableCell align="left">
    <Typography sx={cellSx}>{value}</Typography>
  </TableCell>
);

const TwitterJobResultTable: FC<{ rows?: TwitterAdCreateResult[] }> = ({ rows }) => (
  <TableContainer sx={{ width: '100%' }}>
    <Table sx={{ minWidth: 650 }} aria-label="X ads creation result">
      <TableHead>
        <TableRow>
          <TableCell sx={{ minWidth: 140 }}>Account</TableCell>
          <TableCell sx={{ minWidth: 200 }}>Campaign</TableCell>
          <TableCell sx={{ minWidth: 200 }}>Ad group</TableCell>
          <TableCell sx={{ minWidth: 200 }}>Creative</TableCell>
          <TableCell align="center" sx={{ minWidth: 80 }}>
            Result
          </TableCell>
          <TableCell sx={{ minWidth: 140 }}>Post ID</TableCell>
          <TableCell sx={{ minWidth: 140 }}>Ad ID</TableCell>
          <TableCell>Message</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows?.map((row, index) => (
          <TableRow
            key={`${index}:${row.line_item_id}:${row.creative_name}`}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <Cell value={row.account_id} />
            <Cell value={row.campaign_name} />
            <Cell value={row.line_item_name} />
            <Cell value={row.creative_name} />
            <TableCell align="center">{row.success ? '✅' : '❌'}</TableCell>
            <Cell value={row.post_id} />
            <Cell value={row.ad_id} />
            <Cell value={row.message_details} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TwitterJobResultTable;
